const FUEL_TYPES = {
  lpg: { name: "lpg", id: 7 },
  diesel: { name: "diesel", id: 5 },
  dieselPlus: { name: "dieselPlus", id: 133 },
  petrol92: { name: "petrol92", id: 92 },
  petrol95e: { name: "petrol95e", id: 955 },
  petrol95: { name: "petrol95", id: 95 },
  petrol95Plus: { name: "petrol95Plus", id: 96 },
  petrol98: { name: "petrol98", id: 98 },
  petrol100: { name: "petrol100", id: 100 },
};

export default FUEL_TYPES;
